module.exports = __webpack_public_path__ + "img/31800.81343084.jpg";